module.exports = __webpack_public_path__ + "static/media/3-1.b114e190.jpg";